import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom';
import Release from './release'
import axios from '../../../data/http/axios';
import Column from '~/Common-Objects/Grids/Column/Column';
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import Row from '~/Common-Objects/Grids/Row/Row';
import DateTimeFunctions from '../../../Classes/dateTimeFunctions';

export default function ReleasesTemplate() {
    const { id } = useParams()
    const history = useHistory()
    const [releases, setReleases] = useState(null)

    useEffect(() => {
        axios.get('/release').then(res => {
            setReleases(res.data)
        })
    }, [])

    if (!releases) return <LoadingIcons />

    let selected = id
    if (!selected && releases && releases.length) selected = releases[0].id

    return (
        <Row>
            <Column xs={12} sm={12} md={10} lg={8} className='col-md-offset-1 col-lg-offset-2'>
                <Paper style={{ height: 'calc(100vh - 130px)', overflow: 'auto' }}>
                    <div className='releases'>
                        <div className="releases-list">
                            <ul>
                                <h4 className='mar-b25'>Releases</h4>
                                {releases.map(r => <li
                                    key={r.id}
                                    className={"releases-list-item " + (selected == r.id ? 'releases-list-item-selected' : '')}
                                    onClick={() => history.push('/cp/releases/' + r.id)}
                                >
                                    <div className='releases-list-item-date'>{DateTimeFunctions.formatDateTime(r.releaseDate, "2")}</div>
                                    <div className='releases-list-item-title'>{r.title}</div>
                                </li>)}
                            </ul>
                        </div>
                        <div className='releases-item'>
                            {!!selected && <Release id={selected} />}
                        </div>
                    </div>
                </Paper>
            </Column>
        </Row>
    )
}